import { useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment/moment";
import { Text } from "@radix-ui/themes";
import PATH from "../config/PATH";
import Popups from "./popups";
import Buttons from "./popups/Buttons";
import avatarDefault from "../assets/images/avatarDefault.svg";
import imgExit from "@assets/web-v3-images/icons/exits.png";
import confettiImg from "@assets/web-v3-images/congratulation-popup-1.png";
import popupWinnerHead from "@assets/web-v3-images/popup-winner-head.png";
import popupWinnerBg from "@assets/web-v3-images/popup-winner-bg.png";
import popupWinnerPrizeBase from "@assets/web-v3-images/popup-winner-prize-base.png";
import prizeTag from "@assets/web-v3-images/prize-tag.png";

// Popup "Last week's winner" — hiện khi user không thắng tuần trước (PU2).
function ModalWinner({ result, isWinner, open, onCancel }) {
  const { t } = useTranslation();
  const [urlAvarta, setUrlAvarta] = useState(null);

  const handleClose = () => onCancel?.();

  const handleOk = () => {
    onCancel?.();
    // window.location.href = `${PATH.BID}/running`;
  };

  const handleChangUrlImage = () => {
    setUrlAvarta(avatarDefault);
  };

  const listImageProduct = result?.product_image?.split(",");

  // Only show after 2026-04-30 (the product's go-live date guard)
  const isCheckDate = !moment().isBefore(moment("2026-04-30", "YYYY-MM-DD"));

  return (
    <Popups
      open={open && isCheckDate}
      onOpenChange={(isOpen) => !isOpen && handleClose()}
      className="!bg-transparent !shadow-none !p-0 !overflow-visible"
    >
      <div className="relative w-full">
        {/* Confetti vàng phủ toàn popup */}
        <img
          src={confettiImg}
          alt=""
          className="pointer-events-none absolute inset-x-0 -top-45 z-30 h-auto w-full"
        />

        {/* <img
          src={imgExit}
          alt=""
          className="btn-click-active absolute right-[4%] top-[2%] z-30 w-[9%]"
          onClick={handleClose}
        /> */}

        <div className="relative mx-auto w-[84%]">
          {/* ── Vương miện + vòng nguyệt quế: ảnh popup-winner-head.png có sẵn lỗ
              tròn trong suốt ở giữa — chỉ cần đặt avatar NẰM DƯỚI ảnh này, phần
              viền vàng sẽ tự che mép avatar mà không cần bo/clip riêng. Rộng
              bằng đúng bề ngang card (w-full) để lấp đầy như design; translateY
              tính lại theo cùng tỉ lệ chồng mép ~10.5% chiều cao card khi phóng
              to (trước đó width 46% dùng -55%, giờ width 100% -> -79%). */}
          <div className="absolute left-1/2 top-0 z-20 w-full -translate-x-1/2 translate-y-[-57%]">
            <div className="relative aspect-[816/544]">
              <img
                src={urlAvarta || result?.image || avatarDefault}
                onError={handleChangUrlImage}
                alt=""
                className="absolute rounded-full object-cover"
                style={{ top: "30%", left: "40%", width: "21%", aspectRatio: "1 / 1" }}
              />
              <img src={popupWinnerHead} alt="" className="relative h-auto w-full" />
            </div>
          </div>

          {/* ── Card nền kem: popup-winner-bg.png, khoá tỉ lệ khung để nội dung
              overlay theo % luôn khớp đúng vị trí trên ảnh. */}
          <div className="@container relative z-10">
            <div className="relative aspect-[816/1070]">
              <img src={popupWinnerBg} alt="" className="absolute inset-0 h-full w-full" />

              {/* Bệ đỡ sản phẩm — đặt SAU ảnh nền, TRƯỚC lớp nội dung nên tự
                  động nằm dưới ảnh sản phẩm lẫn nút Awesome (không cần z-index
                  riêng, thứ tự DOM quyết định lớp vẽ). Rộng gần khít bề ngang
                  card theo yêu cầu design. */}
              <img
                src={popupWinnerPrizeBase}
                alt=""
                className="absolute left-1/2 top-[25%] w-[86%] -translate-x-1/2"
              />

              <div className="absolute inset-0 flex flex-col items-center px-[10%] pt-[12%] text-center">
                <Text as="p" className="text-[5.9cqw] font-extrabold text-[#772917]">
                  {t("result_page.popup_winner_subtitle")}
                </Text>

                {/* Pill số điện thoại — cùng kỹ thuật với GuessTicker (Home):
                    nền gradient đỏ-cam viền sáng trên/dưới + chữ 2 lớp
                    (viền đỏ đậm phía dưới, gradient kem-vàng phía trên). */}
                <div
                  className="relative mt-[4cqw] flex items-center justify-center bg-linear-to-r from-[#F2000B]/0 via-[#FF4D11] to-[#F2000B]/0 px-[8cqw] py-[1.6cqw]
                    before:absolute before:inset-x-0 before:top-0 before:h-0.75 before:bg-linear-to-r before:from-[#FAECA9]/0 before:via-[#FAECA9] before:to-[#FAECA9]/0 before:content-['']
                    after:absolute after:inset-x-0 after:bottom-0 after:h-0.75 after:bg-linear-to-r after:from-[#FAECA9]/0 after:via-[#FAECA9] after:to-[#FAECA9]/0 after:content-['']"
                >
                  <p className="inline-grid whitespace-nowrap text-[5cqw] font-extrabold">
                    <span
                      aria-hidden="true"
                      style={{ WebkitTextStroke: "2px #B7220D" }}
                      className="col-start-1 row-start-1 text-[#B7220D] [text-shadow:0_2px_2px_#B7220D]"
                    >
                      {result?.isdn}
                    </span>
                    <span className="col-start-1 row-start-1 text-transparent bg-linear-to-b from-[#FBF5DA] to-[#FDEFB0] bg-clip-text">
                      {result?.isdn}
                    </span>
                  </p>
                </div>

                <div className="relative w-[80%]">
                  <img
                    src={listImageProduct?.[0]}
                    alt=""
                    className="relative z-10 h-auto w-full object-contain drop-shadow-[0_10px_15px_rgba(0,0,0,.25)]"
                  />

                  {/* Tag tên sản phẩm + ngày — cùng ảnh/kỹ thuật với tag giá của
                      PrizeShowcase (Home): prize-tag.png + chữ 2 lớp xoay nghiêng
                      theo độ nghiêng biển tag. */}
                  <div className="@container absolute -right-[20%] bottom-[8%] aspect-321/256 w-[60%] z-[99]">
                    <img src={prizeTag} alt="" className="size-full" />
                    <div className="absolute inset-x-[6%] inset-y-0 grid grid-cols-1 content-center gap-1 rotate-[-7.5deg] pt-[18%] text-center">
                      {/* grid-cols-1 (track = minmax(0,1fr)) để cột rộng đúng bằng
                          biển tag; có mốc bề rộng thì `truncate` mới cắt được tên
                          sản phẩm dài. Nếu để place-content-center như cũ, track tự
                          nở theo chữ nên không bao giờ tràn -> không ra ellipsis. */}
                      <p
                        title={result?.product_name}
                        className="truncate text-[12cqw] font-extrabold leading-tight text-[#FEF0C7]"
                      >
                        {result?.product_name}
                      </p>
                      {result?.end_time && (
                        <p className="whitespace-nowrap text-[5.5cqw] font-bold leading-tight text-[#FEF0C7]">
                          {moment(result.end_time).format("DD/MM/YYYY")}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="mt-[7cqw] w-full px-[8%]">
                  <Buttons handleClick={handleOk} textBtn={t("result_page.popup_winner_cta")} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Popups>
  );
}

export default ModalWinner;
